import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectCurrencyData = createSelector(
  [selectPartner360Data],
  ({ currencyData }) => currencyData
)
